<template>
  <b-container fluid>
    <b-row>
        <b-col lg="12" sm="12" md="12">
        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
                <b-row>
                <b-col lg="6" sm="12" md="4">
                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="fiscal_year_id "
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                            plain
                            v-model="search.fiscal_year_id"
                            id="fiscal_year_id"
                            :options="fiscalYearList"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="6" sm="12">
                    <ValidationProvider name="Organization" vid="org_id" rules="">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="organiation_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{$t('globalTrans.organization')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.org_id"
                            :options="orgList"
                            id="organiation_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="6" sm="12">
                    <ValidationProvider name="Institute Type" vid="office_type_id" rules="">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="office_type_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{$t('child_configuration.institute_type')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.office_type_id"
                            :options="officeTypeList"
                            id="office_type_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="6" sm="12">
                    <ValidationProvider name="Institute Name" vid="office_id" rules="">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="office_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{$t('child_configuration.institute_name')}}
                            </template>
                            <b-form-select
                            plain
                            v-model="search.office_id"
                            :options="officeList"
                            id="office_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" sm="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="from_date"
                        >
                            <template v-slot:label>
                                {{$t('sales_distribution_admin.from_date')}}
                            </template>
                            <b-form-input class="form-control"
                            v-model="search.from_date"
                            placeholder="Select From Date"
                            id="from_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="to_date"
                        >
                            <template v-slot:label>
                                {{$t('sales_distribution_admin.to_date')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.to_date"
                                placeholder="Select To Date"
                                id="to_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <ValidationProvider name="Report Type" vid="report_type" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="report_type"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('child_reports.report_type')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="search.report_type"
                                :options="reportTypeList"
                                id="report_type"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col xs="12" sm="12" md="6">
                    <b-button type="submit" variant="primary">{{ $t('globalTrans.report') }}</b-button>
                </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
        </b-col>
    </b-row>
    <hr>
    <b-row>
        <b-col md="12">
            <b-row v-if="loaded">
                <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                </b-col>
                <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                        <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                        <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                        <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                        <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                        <div class="titleDiv">
                        <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('child_reports.evaluation_management_report') }}</span><br>
                        </div>
                </b-col>
                <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                    <b-button-group>
                        <b-button @click="pdfExport" variant="success" class="mr-2">{{  $t('globalTrans.export_pdf') }}</b-button>
                        <b-button variant="warning">
                              <export-excel
                                worksheet="Report Sheet"
                                :title=headerValue
                                :data=excelData
                                name="evaluation-management-report.xls">
                                {{ $t('globalTrans.export_excel') }}
                              </export-excel>
                            </b-button>
                    </b-button-group>
                </b-col>
                <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                <b-row>
                    <b-col xs="12" sm="12" md="6" class="text-left">
                        <div v-if="titleData.org_name" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ titleData.org_name }}</div>
                        <div v-if="titleData.institute_type_name" class="text-dark"><b>{{ $t('child_configuration.institute_type') }} </b>: {{ titleData.institute_type_name }}</div>
                        <div v-if="titleData.institute_name" class="text-dark"><b>{{ $t('child_configuration.institute_name') }} </b>: {{ titleData.institute_name }}</div>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-right">
                        <div v-if="titleData.report_type" class="text-dark"><b>{{ $t('child_reports.report_type') }} </b>: {{ titleData.report_type }}</div>
                        <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ titleData.year }}</span>
                        <br /><span v-if="titleData.from_date !== '' && titleData.to_date !== ''" class="text-center text-dark"><b>{{ $t('globalTrans.date') }} </b>: {{ $d(new Date(titleData.from_date)) }} <b>{{ $t('sales_distribution_admin.to') }} </b>{{ $d(new Date(titleData.to_date)) }}</span>
                        <span v-if="titleData.from_date !== '' && titleData.to_date === ''" class="text-center text-dark"><b>{{ $t('globalTrans.date') }} </b>: {{ $d(new Date(titleData.from_date)) }}</span>
                    </b-col>
                </b-row>
                </b-col>
            </b-row>
            <b-overlay :show="loadingState">
                <b-row>
                    <b-col lg="12" xs="12" md="12">
                        <b-table style="font-size: 12px !important" thead-class="bg-primary" bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                            <template v-slot:cell(index)="data">
                                {{ $n(data.index + 1) }}
                            </template>
                            <template v-slot:cell(evaluation_setting)="data">
                                <div v-for="(evaluation, index) in data.item.details" :key="index">
                                    {{ getEvaluationName(evaluation) }}
                                </div>
                            </template>
                            <template v-slot:cell(obtain_m)="data">
                                <div v-for="(evaluation, index) in data.item.details" :key="index">
                                    {{ $n(evaluation.obtain_marks) }}
                                </div>
                            </template>
                            <template v-slot:cell(total_m)="data" style="v-align:center">
                                {{ getTotal(data.item.details) }}
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-overlay>
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { evaluationReportApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-all-pdf'
import flatpickr from 'flatpickr'
import excel from 'vue-excel-export'
import ExportExcel from './export-excel'
import Vue from 'vue'
Vue.use(excel)

export default {
mixins: [RouteBasedList],
   components: {
        ValidationObserver,
        ValidationProvider
   },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      search: {
            fiscal_year_id: 0,
            org_id: 0,
            office_type_id: 0,
            office_id: 0,
            report_type: 2,
            from_date: '',
            to_date: '',
            start_date: '',
            end_date: ''
      },
      titleData: {
        year: '',
        from_date: '',
        to_date: '',
        org_name: '',
        institute_type_name: '',
        institute_name: '',
        report_type: ''
      },
      officeTypeList: [],
      officeList: [],
      report_data: [],
      rows: [],
      reportHeadData: '',
      loaded: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    excelData: function () {
      return ExportExcel.excelBody(this)
    },
    headerValue: function () {
      const title = this.$t('child_reports.evaluation_management_report')
      return ExportExcel.headerData(title)
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    evaluationList: function () {
        return this.$store.state.ChildService.commonObj.evaluationSettingList.filter(item => item.status === 1)
    },
    reportTypeList: function () {
        if (this.$i18n.locale === 'bn') {
            const data = [
                { value: 2, text: 'সাপ্তাহিক' },
                { value: 3, text: 'মাসিক' }
            ]
            return data
        } else {
            const data = [
                { value: 2, text: 'Weekly' },
                { value: 3, text: 'Monthly' }
            ]
            return data
        }
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('institute_manangement.evaluation_date'), class: 'text-left' },
          { label: this.$t('rehabilitation_management.registration_id'), class: 'text-left' },
          { label: this.$t('child_reports.resident_name'), class: 'text-left' },
          { label: this.$t('child_reports.evaluation_setting'), class: 'text-left' },
          { label: this.$t('child_reports.obtain_m'), class: 'text-left' },
          { label: this.$t('child_reports.total_m'), class: 'text-left' },
          { label: this.$t('globalTrans.remarks'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'evaluation_date' },
          { key: 'registration_id' },
          { key: 'name_bn' },
          { key: 'evaluation_setting' },
          { key: 'obtain_m' },
          { key: 'total_m' },
          { key: 'remarks' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'evaluation_date' },
          { key: 'registration_id' },
          { key: 'name' },
          { key: 'evaluation_setting' },
          { key: 'obtain_m' },
          { key: 'total_m' },
          { key: 'remarks' }
        ]
      }

      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.from_date': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.report_data = []
            this.titleData.from_date = this.search.from_date
        }
    },
    'search.to_date': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.report_data = []
            this.titleData.to_date = this.search.to_date
        }
    },
    'search.org_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeTypeList()
       this.getOrgName()
      } else {
        this.titleData.org_name = ''
      }
      this.report_data = []
    },
    'search.office_type_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeList()
       this.getOfficeTypeName()
      } else {
        this.titleData.institute_type_name = ''
      }
    },
    'search.office_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeName()
      } else {
        this.titleData.institute_name = ''
      }
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
        this.getFiscalYear()
        this.report_data = []
      } else {
          this.titleData.year = ''
          this.report_data = []
      }
    },
    'search.report_type': function (newVal) {
        this.getReportType(newVal)
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
                this.getOrgName()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
                this.getOfficeTypeName()
            }
            if (this.search.office_id) {
                this.getOfficeName()
            }
            if (this.search.fiscal_year_id) {
              this.getFiscalYear()
            }
            this.getReportType()
            this.headerName()
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.headerName()
    this.getReportType()
  },
  mounted () {
    flatpickr('#to_date', {})
    flatpickr('#from_date', {})
  },
  methods: {
    getTotal (data) {
        let total = 0
        data.map(item => {
            total = total + parseInt(item.obtain_marks)
        })
        const intotal = this.$n(total)
        return intotal
    },
    getEvaluationName (data) {
        const evaluation = this.evaluationList.find(item => item.value === data.evaluation_settings_id)
        if (this.$i18n.locale === 'bn') {
          return evaluation.text_bn
        } else {
          return evaluation.text_en
        }
    },
    getFiscalYear () {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.search.fiscal_year_id)
        if (this.$i18n.locale === 'bn') {
            this.titleData.year = Year.text_bn
        } else {
            this.titleData.year = Year.text_en
        }
        this.search.start_date = Year.start_date
        this.search.end_date = Year.end_date
    },
    searchData () {
      this.loadData()
    },
    getReportType () {
        const Reptype = this.reportTypeList.find(item => item.value === this.search.report_type)
        this.titleData.report_type = Reptype.text
    },
    getOrgName () {
      const Org = this.$store.state.commonObj.organizationProfileList.find(item => item.status === 0 && item.value === this.search.org_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.org_name = Org.text_bn
      } else {
          this.titleData.org_name = Org.text_en
      }
    },
    getOfficeTypeName () {
      const Org = this.$store.state.commonObj.officeTypeList.find(item => item.status === 0 && item.value === this.search.office_type_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_type_name = Org.text_bn
      } else {
          this.titleData.institute_type_name = Org.text_en
      }
    },
    getOfficeName () {
      const Org = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === this.search.office_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_name = Org.text_bn
      } else {
          this.titleData.institute_name = Org.text_en
      }
    },
    getInstituteType (Id) {
      const Org = this.$store.state.commonObj.officeTypeList.find(item => item.status === 0 && item.value === Id)
      if (this.$i18n.locale === 'bn') {
          return Org.text_bn
      } else {
          return Org.text_en
      }
    },
    getInstituteName (Id) {
      const Org = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === Id)
      if (this.$i18n.locale === 'bn') {
          return Org.text_bn
      } else {
          return Org.text_en
      }
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const params = Object.assign({}, this.search)
      RestApi.getData(childServiceBaseUrl, evaluationReportApi, params).then(response => {
        if (response.success) {
            this.report_data = response.data
        } else {
            this.report_data = []
            this.$toast.error({
                title: this.$t('globalTrans.error'),
                message: this.$t('globalTrans.noDataFound')
            })
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(childServiceBaseUrl, 'configuration/report-heading/detail', 2)
       this.reportHeadData = headdata
       this.loaded = true
    },
    pdfExport () {
      const reportTitle = this.$t('child_reports.evaluation_management_report')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, this.report_data, this, this.titleData)
    }
  }
}
</script>
<style scoped>
.reportTitle {
  font-weight: bold;
    border: 1px solid;
    padding: 8px 15px 8px 15px;
    border-radius: 11px;
}
.titleDiv {
  margin-top: 1.2rem;
  font-size: 18px;
}
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
